module.exports = __webpack_public_path__ + "media/src/images/lp/dummyback-18693851f6eb74d0b1fc58ecaa90f6b6.png";